function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _excluded = ["offset", "limit"],
    _excluded2 = ["route", "perPage", "children", "getTotalCount", "primaryKey", "count", "topPagination", "bottomPagination", "extraPagination", "params", "opts"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import { Component } from "react";
import h from "@macrostrat/hyper";
import { Button, ButtonGroup, NonIdealState } from "@blueprintjs/core";
import { APIResultView } from "./frontend";

var Pagination = function Pagination(props) {
  var currentPage = props.currentPage,
      nextDisabled = props.nextDisabled,
      setPage = props.setPage;
  return h(ButtonGroup, [h(Button, {
    onClick: setPage(currentPage - 1),
    icon: "arrow-left",
    disabled: currentPage <= 0
  }, "Previous"), h(Button, {
    onClick: setPage(currentPage + 1),
    rightIcon: "arrow-right",
    disabled: nextDisabled
  }, "Next")]);
};

var PagedAPIView = /*#__PURE__*/function (_Component) {
  _inherits(PagedAPIView, _Component);

  var _super = _createSuper(PagedAPIView);

  function PagedAPIView(props) {
    var _this;

    _classCallCheck(this, PagedAPIView);

    _this = _super.call(this, props);
    _this.setPage = _this.setPage.bind(_assertThisInitialized(_this));
    _this.params = _this.params.bind(_assertThisInitialized(_this));
    _this.state = {
      currentPage: 0,
      count: null
    };
    return _this;
  }

  _createClass(PagedAPIView, [{
    key: "setPage",
    value: function setPage(i) {
      var _this2 = this;

      return function () {
        return _this2.setState({
          currentPage: i
        });
      };
    }
  }, {
    key: "renderPagination",
    value: function renderPagination() {
      var perPage = this.props.perPage;
      var count = this.state.count;
      var nextDisabled = false;
      var paginationInfo = null;
      var currentPage = this.currentPage();
      var lastPage = this.lastPage();

      if (lastPage != null) {
        if (currentPage >= lastPage) {
          currentPage = lastPage;
          nextDisabled = true;
        }

        paginationInfo = h("div", {
          disabled: true
        }, ["".concat(currentPage + 1, " of ").concat(lastPage + 1, " (").concat(count, " records)")]);
      }

      return h("div.pagination-controls", [h(Pagination, {
        currentPage: currentPage,
        nextDisabled: nextDisabled,
        setPage: this.setPage
      }), this.props.extraPagination, paginationInfo]);
    }
  }, {
    key: "lastPage",
    value: function lastPage() {
      var count = this.state.count;
      var perPage = this.props.perPage;

      if (count == null) {
        return null;
      }

      var pages = Math.floor(count / perPage);

      if (count % perPage === 0) {
        pages -= 1;
      }

      return pages;
    }
  }, {
    key: "currentPage",
    value: function currentPage() {
      var currentPage = this.state.currentPage;
      var lastPage = this.lastPage();

      if (lastPage != null && currentPage >= lastPage) {
        return lastPage;
      }

      if (currentPage < 0) {
        currentPage = 0;
      }

      return currentPage;
    }
  }, {
    key: "params",
    value: function params() {
      var _this$props = this.props,
          params = _this$props.params,
          perPage = _this$props.perPage;

      var offset = params.offset,
          limit = params.limit,
          otherParams = _objectWithoutProperties(params, _excluded);

      var currentPage = this.currentPage();

      if (offset == null) {
        offset = 0;
      }

      offset += currentPage * perPage; // This shouldn't happen but it does

      if (offset < 0) {
        offset = 0;
      }

      if (limit == null || limit > perPage) {
        limit = perPage;
      }

      return _objectSpread({
        offset: offset,
        limit: limit
      }, otherParams);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          route = _this$props2.route,
          perPage = _this$props2.perPage,
          children = _this$props2.children,
          getTotalCount = _this$props2.getTotalCount,
          primaryKey = _this$props2.primaryKey,
          count = _this$props2.count,
          topPagination = _this$props2.topPagination,
          bottomPagination = _this$props2.bottomPagination,
          extraPagination = _this$props2.extraPagination,
          params = _this$props2.params,
          opts = _this$props2.opts,
          rest = _objectWithoutProperties(_this$props2, _excluded2);

      params = this.params(); // Create new onResponse function

      var _opts = opts,
          __onResponse = _opts.onResponse;

      var onResponse = function onResponse(response) {
        count = getTotalCount(response);

        _this3.setState({
          count: count
        }); // Run inherited onResponse if it exists


        if (__onResponse != null) {
          return __onResponse(response);
        }
      }; // Options for get


      opts = _objectSpread(_objectSpread({}, opts), {}, {
        onResponse: onResponse
      });

      var _children = function _children(data) {
        if (_this3.state.count === 0) {
          return h(NonIdealState, {
            icon: "search",
            title: "No results"
          });
        } // @ts-ignore


        return children(data);
      };

      return h("div.pagination-container", rest, [topPagination ? this.renderPagination() : undefined, h(APIResultView, {
        route: route,
        params: params,
        opts: opts,
        primaryKey: primaryKey
      }, _children), bottomPagination ? this.renderPagination() : undefined]);
    }
  }]);

  return PagedAPIView;
}(Component);

_defineProperty(PagedAPIView, "defaultProps", {
  count: null,
  perPage: 20,
  topPagination: false,
  bottomPagination: true,
  extraPagination: null,
  opts: {},
  // Options passed to GET
  params: {},
  getTotalCount: function getTotalCount(response) {
    var headers = response.headers;
    return parseInt(headers["x-total-count"]);
  }
});

export { PagedAPIView, Pagination };